import React from 'react';

/*
 * IMPORTANT! *
 *******************************************************************************************
 * Update the Info360AboutBoxText.md file in order to have the most recent version of the text.
 * exported using Typora (mac) and then converted to a static html file
 * File -> export -> html
 *******************************************************************************************
 */

export const aboutBoxTextWithStylesV1 = (
	<>
		{/* Invisible element with the version of the style */}
		<div style={{ display: 'none' }}>About box v2025.05.22</div>
		<p>
			<strong>
				Info360 &copy; 2025 Autodesk, Inc. All rights reserved.
			</strong>
		</p>
		<strong>
			All use of this Software is subject to the terms of service accepted
			upon access or use of this Service or made available on the
			applicable Autodesk webpage.
		</strong>
		<br />
		<br />
		<p>
			<strong>
				The terms of service for Info360 Asset, Info360 Insight and
				Info360 Plant can be found
			</strong>
			&nbsp;
			<a
				href="https://www.autodesk.com/company/terms-of-use/en/general-terms"
				target="_blank"
				rel="noopener noreferrer">
				here
			</a>
			.
		</p>
		<h2 id="privacy">Privacy</h2>
		<p>
			To learn more about Autodesk&rsquo;s online and offline privacy
			practices, please see the{' '}
			<a
				href="http://www.autodesk.com/company/legal-notices-trademarks/privacy-statement"
				target="_blank"
				rel="noopener noreferrer">
				Autodesk Privacy Statement
			</a>
			.
		</p>
		<h2 id="autodesk-trademarks">Autodesk Trademarks</h2>
		<p>
			The trademarks on the{' '}
			<a
				href="https://www.autodesk.com/company/legal-notices-trademarks/intellectual-property/trademarks"
				target="_blank"
				rel="noopener noreferrer">
				Autodesk Trademarks page
			</a>
			are registered trademarks or trademarks of Autodesk, Inc., and/or
			its subsidiaries and/or affiliates in the USA and/or other
			countries.
		</p>
		<p>
			All other brand names, product names or trademarks belong to their
			respective holders.
		</p>
		<h2 id="patents">Patents</h2>
		<p>
			This Product or Service is protected by patents listed on the{' '}
			<a
				href="https://www.autodesk.com/company/legal-notices-trademarks/patents"
				target="_blank"
				rel="noopener noreferrer">
				Autodesk Patents
			</a>{' '}
			page.
		</p>
		<h2 id="autodesk-cloud-and-desktop-components">
			Autodesk Cloud and Desktop Components
		</h2>
		<p>
			This Product or Service may incorporate or use background Autodesk
			online and desktop technology components. For information about
			these components, see{' '}
			<a
				href="https://www.autodesk.com/company/legal-notices-trademarks/autodesk-cloud-platform-components"
				target="_blank"
				rel="noopener noreferrer">
				Autodesk Cloud Platform Components
			</a>{' '}
			and{' '}
			<a
				href="https://www.autodesk.com/company/legal-notices-trademarks/autodesk-desktop-platform-components"
				target="_blank"
				rel="noopener noreferrer">
				Autodesk Desktop Platform Components
			</a>
			.
		</p>
		<h2 id="third-party-trademarks-software-credits-and-attributions">
			Third-Party Trademarks, Software Credits and Attributions
		</h2>
		<h2 id="aniso8601">aniso8601:</h2>
		<h3 id="copyright--2021-brandon-nielsen">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2021, Brandon Nielsen
		</h3>
		<p>All rights reserved.</p>
		<p>
			Redistribution and use in source and binary forms, with or without
			modification, are permitted provided that the following conditions
			are met:
		</p>
		<ol>
			<li>
				Redistributions of source code must retain the above copyright
				notice, this list of conditions and the following disclaimer.
			</li>
			<li>
				Redistributions in binary form must reproduce the above
				copyright notice, this list of conditions and the following
				disclaimer in the documentation and/or other materials provided
				with the distribution.
			</li>
			<li>
				Neither the name of the copyright holder nor the names of its
				contributors may be used to endorse or promote products derived
				from this software without specific prior written permission.
			</li>
		</ol>
		<p>
			THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
			&quot;AS IS&quot; AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING,
			BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
			FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL
			THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
			INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
			(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
			SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
			HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
			STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
			ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
			OF THE POSSIBILITY OF SUCH DAMAGE.
		</p>
		<h2 id="aws-greengrass-cli">aws-greengrass-cli:</h2>
		<p>
			Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
		</p>
		<p>
			Licensed under the Apache License, Version 2.0 (the
			&quot;License&quot;); you may not use this file except in compliance
			with the License. You may obtain a copy of the License at{' '}
			<a
				href="http://www.apache.org/licenses/LICENSE-2.0"
				target="_blank"
				rel="noopener noreferrer">
				http://www.apache.org/licenses/LICENSE-2.0
			</a>
			&nbsp;
		</p>
		<p>
			Unless required by applicable law or agreed to in writing, software
			distributed under the License is distributed on an &quot;AS IS&quot;
			BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
			or implied. See the License for the specific language governing
			permissions and limitations under the License.
		</p>
		<h2 id="aws-greengrass-core-sdk">aws-greengrass-core-sdk:</h2>
		<p>
			Copyright 2012-2018 Amazon.com, Inc. or its affiliates. All Rights
			Reserved.
		</p>
		<p>
			Licensed under the Apache License, Version 2.0 (the
			&quot;License&quot;); you may not use this file except in compliance
			with the License. You may obtain a copy of the License at{' '}
			<a
				href="http://www.apache.org/licenses/LICENSE-2.0"
				target="_blank"
				rel="noopener noreferrer">
				http://www.apache.org/licenses/LICENSE-2.0
			</a>
			&nbsp;
		</p>
		<p>
			Unless required by applicable law or agreed to in writing, software
			distributed under the License is distributed on an &quot;AS IS&quot;
			BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
			or implied. See the License for the specific language governing
			permissions and limitations under the License.
		</p>
		<h2 id="aws-greengrass-log-manager">aws-greengrass-log-manager:</h2>
		<p>
			Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
		</p>
		<p>
			Licensed under the Apache License, Version 2.0 (the
			&quot;License&quot;); you may not use this file except in compliance
			with the License. You may obtain a copy of the License at{' '}
			<a
				href="http://www.apache.org/licenses/LICENSE-2.0"
				target="_blank"
				rel="noopener noreferrer">
				http://www.apache.org/licenses/LICENSE-2.0
			</a>
			&nbsp;
		</p>
		<p>
			Unless required by applicable law or agreed to in writing, software
			distributed under the License is distributed on an &quot;AS IS&quot;
			BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
			or implied. See the License for the specific language governing
			permissions and limitations under the License.
		</p>
		<h2 id="aws-greengrass-nucleus">aws-greengrass-nucleus:</h2>
		<p>
			Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
		</p>
		<p>
			Licensed under the Apache License, Version 2.0 (the
			&quot;License&quot;); you may not use this file except in compliance
			with the License. You may obtain a copy of the License at{' '}
			<a
				href="http://www.apache.org/licenses/LICENSE-2.0"
				target="_blank"
				rel="noopener noreferrer">
				http://www.apache.org/licenses/LICENSE-2.0
			</a>
			&nbsp;
		</p>
		<p>
			Unless required by applicable law or agreed to in writing, software
			distributed under the License is distributed on an &quot;AS IS&quot;
			BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
			or implied. See the License for the specific language governing
			permissions and limitations under the License.
		</p>
		<h2 id="aws-greengrass-stream-manager">
			aws-greengrass-stream-manager:
		</h2>
		<p>
			Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
		</p>
		<p>
			Licensed under the Apache License, Version 2.0 (the
			&quot;License&quot;); you may not use this file except in compliance
			with the License. You may obtain a copy of the License at{' '}
			<a
				href="http://www.apache.org/licenses/LICENSE-2.0"
				target="_blank"
				rel="noopener noreferrer">
				http://www.apache.org/licenses/LICENSE-2.0
			</a>
			&nbsp;
		</p>
		<p>
			Unless required by applicable law or agreed to in writing, software
			distributed under the License is distributed on an &quot;AS IS&quot;
			BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
			or implied. See the License for the specific language governing
			permissions and limitations under the License.
		</p>
		<h2 id="aws-greengrass-telemtry-nucleus-emitter">
			aws-greengrass-telemtry-nucleus-emitter:
		</h2>
		<p>
			Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
		</p>
		<p>
			Licensed under the Apache License, Version 2.0 (the
			&quot;License&quot;); you may not use this file except in compliance
			with the License. You may obtain a copy of the License at{' '}
			<a
				href="http://www.apache.org/licenses/LICENSE-2.0"
				target="_blank"
				rel="noopener noreferrer">
				http://www.apache.org/licenses/LICENSE-2.0
			</a>
			&nbsp;
		</p>
		<p>
			Unless required by applicable law or agreed to in writing, software
			distributed under the License is distributed on an &quot;AS IS&quot;
			BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
			or implied. See the License for the specific language governing
			permissions and limitations under the License.
		</p>
		<h2 id="aws-iot-device-sdk">aws-iot-device-sdk:</h2>
		<p>
			Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
		</p>
		<p>
			Licensed under the Apache License, Version 2.0 (the
			&quot;License&quot;); you may not use this file except in compliance
			with the License. You may obtain a copy of the License at{' '}
			<a
				href="http://www.apache.org/licenses/LICENSE-2.0"
				target="_blank"
				rel="noopener noreferrer">
				http://www.apache.org/licenses/LICENSE-2.0
			</a>
			&nbsp;
		</p>
		<p>
			Unless required by applicable law or agreed to in writing, software
			distributed under the License is distributed on an &quot;AS IS&quot;
			BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
			or implied. See the License for the specific language governing
			permissions and limitations under the License.
		</p>
		<h2 id="aws-iot-device-sdk-v2">aws-iot-device-sdk-v2:</h2>
		<p>
			Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
		</p>
		<p>
			Licensed under the Apache License, Version 2.0 (the
			&quot;License&quot;); you may not use this file except in compliance
			with the License. You may obtain a copy of the License at{' '}
			<a
				href="http://www.apache.org/licenses/LICENSE-2.0"
				target="_blank"
				rel="noopener noreferrer">
				http://www.apache.org/licenses/LICENSE-2.0
			</a>
			&nbsp;
		</p>
		<p>
			Unless required by applicable law or agreed to in writing, software
			distributed under the License is distributed on an &quot;AS IS&quot;
			BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
			or implied. See the License for the specific language governing
			permissions and limitations under the License.
		</p>
		<h2 id="aws-sdk">aws-sdk:</h2>
		<p>
			Copyright 2012-2017 Amazon.com, Inc. or its affiliates. All Rights
			Reserved.
		</p>
		<p>
			Licensed under the Apache License, Version 2.0 (the
			&quot;License&quot;); you may not use this file except in compliance
			with the License. You may obtain a copy of the License at{' '}
			<a
				href="http://www.apache.org/licenses/LICENSE-2.0"
				target="_blank"
				rel="noopener noreferrer">
				http://www.apache.org/licenses/LICENSE-2.0
			</a>
			&nbsp;
		</p>
		<p>
			Unless required by applicable law or agreed to in writing, software
			distributed under the License is distributed on an &quot;AS IS&quot;
			BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
			or implied. See the License for the specific language governing
			permissions and limitations under the License.
		</p>
		<h2 id="awscrt">awscrt:</h2>
		<p>
			Copyright 2010-2019 Amazon.com, Inc. or its affiliates. All Rights
			Reserved.
		</p>
		<p>
			Licensed under the Apache License, Version 2.0 (the
			&quot;License&quot;); you may not use this file except in compliance
			with the License. You may obtain a copy of the License at{' '}
			<a
				href="http://www.apache.org/licenses/LICENSE-2.0"
				target="_blank"
				rel="noopener noreferrer">
				http://www.apache.org/licenses/LICENSE-2.0
			</a>
			&nbsp;
		</p>
		<p>
			Unless required by applicable law or agreed to in writing, software
			distributed under the License is distributed on an &quot;AS IS&quot;
			BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
			or implied. See the License for the specific language governing
			permissions and limitations under the License.
		</p>
		<h2 id="awsiotsdk">awsiotsdk:</h2>
		<p>
			Copyright 2010-2017 Amazon.com, Inc. or its affiliates. All Rights
			Reserved.
		</p>
		<p>
			Licensed under the Apache License, Version 2.0 (the
			&quot;License&quot;); you may not use this file except in compliance
			with the License. You may obtain a copy of the License at{' '}
			<a
				href="http://www.apache.org/licenses/LICENSE-2.0"
				target="_blank"
				rel="noopener noreferrer">
				http://www.apache.org/licenses/LICENSE-2.0
			</a>
			&nbsp;
		</p>
		<p>
			Unless required by applicable law or agreed to in writing, software
			distributed under the License is distributed on an &quot;AS IS&quot;
			BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
			or implied. See the License for the specific language governing
			permissions and limitations under the License.
		</p>
		<h2 id="axios">axios:</h2>
		<h3 id="copyright--2014-present-matt-zabriskie">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2014-present Matt Zabriskie.
		</h3>
		<p>
			Permission is hereby granted, free of charge, to any person
			obtaining a copy of this software and associated documentation files
			(the &quot;Software&quot;), to deal in the Software without
			restriction, including without limitation the rights to use, copy,
			modify, merge, publish, distribute, sublicense, and/or sell copies
			of the Software, and to permit persons to whom the Software is
			furnished to do so, subject to the following conditions:
		</p>
		<p>
			The above copyright notice and this permission notice shall be
			included in all copies or substantial portions of the Software.
		</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY
			KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
			WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
			NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
			BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
			ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
			CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
			SOFTWARE.
		</p>
		<h2 id="bee-queue">bee-queue:</h2>
		<p>
			Original work Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2015 Lewis J Ellis
		</p>
		<p>
			Subsequent revisions Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2017 Mixmax, Inc and Lewis J Ellis
		</p>
		<p>
			Permission is hereby granted, free of charge, to any person
			obtaining a copy of this software and associated documentation files
			(the &quot;Software&quot;), to deal in the Software without
			restriction, including without limitation the rights to use, copy,
			modify, merge, publish, distribute, sublicense, and/or sell copies
			of the Software, and to permit persons to whom the Software is
			furnished to do so, subject to the following conditions:
		</p>
		<p>
			The above copyright notice and this permission notice shall be
			included in all copies or substantial portions of the Software.
		</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY
			KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
			WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
			NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
			BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
			ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
			CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
			SOFTWARE.
		</p>
		<h2 id="bottleneck">bottleneck:</h2>
		<h3 id="copyright--2014-simon-grondin">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2014 Simon Grondin
		</h3>
		<p>
			Permission is hereby granted, free of charge, to any person
			obtaining a copy of this software and associated documentation files
			(the &quot;Software&quot;), to deal in the Software without
			restriction, including without limitation the rights to use, copy,
			modify, merge, publish, distribute, sublicense, and/or sell copies
			of the Software, and to permit persons to whom the Software is
			furnished to do so, subject to the following conditions:
		</p>
		<p>
			The above copyright notice and this permission notice shall be
			included in all copies or substantial portions of the Software.
		</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY
			KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
			WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
			NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
			BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
			ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
			CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
			SOFTWARE.
		</p>
		<h2 id="cbor2">cbor2:</h2>
		<h3 id="copyright--2016-alex-grönholm">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2016 Alex Grönholm
		</h3>
		<p>
			Permission is hereby granted, free of charge, to any person
			obtaining a copy of this software and associated documentation files
			(the &quot;Software&quot;), to deal in the Software without
			restriction, including without limitation the rights to use, copy,
			modify, merge, publish, distribute, sublicense, and/or sell copies
			of the Software, and to permit persons to whom the Software is
			furnished to do so, subject to the following conditions:
		</p>
		<p>
			The above copyright notice and this permission notice shall be
			included in all copies or substantial portions of the Software.
		</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY
			KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
			WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
			NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
			BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
			ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
			CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
			SOFTWARE.
		</p>
		<h2 id="click">click:</h2>
		<p>Copyright 2014 Pallets</p>
		<p>
			Redistribution and use in source and binary forms, with or without
			modification, are permitted provided that the following conditions
			are met:
		</p>
		<ol>
			<li>
				Redistributions of source code must retain the above copyright
				notice, this list of conditions and the following disclaimer.
			</li>
			<li>
				Redistributions in binary form must reproduce the above
				copyright notice, this list of conditions and the following
				disclaimer in the documentation and/or other materials provided
				with the distribution.
			</li>
			<li>
				Neither the name of the copyright holder nor the names of its
				contributors may be used to endorse or promote products derived
				from this software without specific prior written permission.
			</li>
		</ol>
		<p>
			THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
			&quot;AS IS&quot; AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING,
			BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
			FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL
			THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
			INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
			(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
			SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
			HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
			STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
			ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
			OF THE POSSIBILITY OF SUCH DAMAGE.
		</p>
		<h2 id="colorama">colorama:</h2>
		<h3 id="copyright--2010-jonathan-hartley">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2010 Jonathan Hartley
		</h3>
		<p>All rights reserved.</p>
		<p>
			Redistribution and use in source and binary forms, with or without
			modification, are permitted provided that the following conditions
			are met:
		</p>
		<ol>
			<li>
				Redistributions of source code must retain the above copyright
				notice, this list of conditions and the following disclaimer.
			</li>
			<li>
				Redistributions in binary form must reproduce the above
				copyright notice, this list of conditions and the following
				disclaimer in the documentation and/or other materials provided
				with the distribution.
			</li>
			<li>
				Neither the name of the copyright holder nor the names of its
				contributors may be used to endorse or promote products derived
				from this software without specific prior written permission.
			</li>
		</ol>
		<p>
			THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
			&quot;AS IS&quot; AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING,
			BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
			FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL
			THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
			INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
			(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
			SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
			HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
			STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
			ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
			OF THE POSSIBILITY OF SUCH DAMAGE.
		</p>
		<h2 id="delay">delay:</h2>
		<h3 id="copyright--sindre-sorhus-sindresorhusgmailcom-httpssindresorhuscom">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			Sindre Sorhus &lt;
			<a
				href="mailto:sindresorhus@gmail.com"
				target="_blank"
				className="url"
				rel="noopener noreferrer">
				sindresorhus@gmail.com
			</a>
			&gt; (
			<a
				href="https://sindresorhus.com"
				target="_blank"
				className="url"
				rel="noopener noreferrer">
				https://sindresorhus.com
			</a>
			)
		</h3>
		<p>
			Permission is hereby granted, free of charge, to any person
			obtaining a copy of this software and associated documentation files
			(the &quot;Software&quot;), to deal in the Software without
			restriction, including without limitation the rights to use, copy,
			modify, merge, publish, distribute, sublicense, and/or sell copies
			of the Software, and to permit persons to whom the Software is
			furnished to do so, subject to the following conditions:
		</p>
		<p>
			The above copyright notice and this permission notice shall be
			included in all copies or substantial portions of the Software.
		</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY
			KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
			WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
			NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
			BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
			ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
			CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
			SOFTWARE.
		</p>
		<h2 id="flask">flask:</h2>
		<h3 id="copyright--2016-opentracing-contrib">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2016, opentracing-contrib
		</h3>
		<p>All rights reserved.</p>
		<p>
			Redistribution and use in source and binary forms, with or without
			modification, are permitted provided that the following conditions
			are met:
		</p>
		<ol>
			<li>
				Redistributions of source code must retain the above copyright
				notice, this list of conditions and the following disclaimer.
			</li>
			<li>
				Redistributions in binary form must reproduce the above
				copyright notice, this list of conditions and the following
				disclaimer in the documentation and/or other materials provided
				with the distribution.
			</li>
			<li>
				Neither the name of the copyright holder nor the names of its
				contributors may be used to endorse or promote products derived
				from this software without specific prior written permission.
			</li>
		</ol>
		<p>
			THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
			&quot;AS IS&quot; AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING,
			BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
			FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL
			THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
			INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
			(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
			SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
			HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
			STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
			ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
			OF THE POSSIBILITY OF SUCH DAMAGE.
		</p>
		<h2 id="flaskrestful">flask_restful:</h2>
		<p>
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2013, Twilio, Inc.
		</p>
		<p>All rights reserved.</p>
		<p>
			Redistribution and use in source and binary forms, with or without
			modification, are permitted provided that the following conditions
			are met:
		</p>
		<ol>
			<li>
				Redistributions of source code must retain the above copyright
				notice, this list of conditions and the following disclaimer.
			</li>
			<li>
				Redistributions in binary form must reproduce the above
				copyright notice, this list of conditions and the following
				disclaimer in the documentation and/or other materials provided
				with the distribution.
			</li>
			<li>
				Neither the name of the copyright holder nor the names of its
				contributors may be used to endorse or promote products derived
				from this software without specific prior written permission.
			</li>
		</ol>
		<p>
			THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
			&quot;AS IS&quot; AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING,
			BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
			FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL
			THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
			INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
			(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
			SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
			HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
			STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
			ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
			OF THE POSSIBILITY OF SUCH DAMAGE.
		</p>
		<h2 id="form-data">form-data:</h2>
		<h3 id="copyright--2012-felix-geisendörfer-felixdebuggablecom-and-contributors">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2012 Felix Geisendörfer (
			<a
				href="mailto:felix@debuggable.com"
				target="_blank"
				className="url"
				rel="noopener noreferrer">
				felix@debuggable.com
			</a>
			) and contributors
		</h3>
		<p>
			Permission is hereby granted, free of charge, to any person
			obtaining a copy of this software and associated documentation files
			(the &quot;Software&quot;), to deal in the Software without
			restriction, including without limitation the rights to use, copy,
			modify, merge, publish, distribute, sublicense, and/or sell copies
			of the Software, and to permit persons to whom the Software is
			furnished to do so, subject to the following conditions:
		</p>
		<p>
			The above copyright notice and this permission notice shall be
			included in all copies or substantial portions of the Software.
		</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY
			KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
			WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
			NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
			BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
			ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
			CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
			SOFTWARE.
		</p>
		<h2 id="greengrasssdk">greengrasssdk:</h2>
		<p>Copyright 2012-2015 Amazon.com, Inc. or its affiliates.</p>
		<p>
			Licensed under the Apache License, Version 2.0 (the
			&quot;License&quot;); you may not use this file except in compliance
			with the License. You may obtain a copy of the License at{' '}
			<a
				href="http://www.apache.org/licenses/LICENSE-2.0"
				target="_blank"
				rel="noopener noreferrer">
				http://www.apache.org/licenses/LICENSE-2.0
			</a>
			&nbsp;
		</p>
		<p>
			Unless required by applicable law or agreed to in writing, software
			distributed under the License is distributed on an &quot;AS IS&quot;
			BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
			or implied. See the License for the specific language governing
			permissions and limitations under the License.
		</p>
		<h2 id="importlibmetadata">importlib_metadata:</h2>
		<p>Copyright 2017-2019 Jason R. Coombs, Barry Warsaw</p>
		<p>
			Licensed under the Apache License, Version 2.0 (the
			&quot;License&quot;); you may not use this file except in compliance
			with the License. You may obtain a copy of the License at{' '}
			<a
				href="http://www.apache.org/licenses/LICENSE-2.0"
				target="_blank"
				rel="noopener noreferrer">
				http://www.apache.org/licenses/LICENSE-2.0
			</a>
			&nbsp;
		</p>
		<p>
			Unless required by applicable law or agreed to in writing, software
			distributed under the License is distributed on an &quot;AS IS&quot;
			BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
			or implied. See the License for the specific language governing
			permissions and limitations under the License.
		</p>
		<h2 id="itsdangerous">itsdangerous:</h2>
		<p>Copyright 2011 Pallets</p>
		<p>
			Redistribution and use in source and binary forms, with or without
			modification, are permitted provided that the following conditions
			are met:
		</p>
		<ol>
			<li>
				Redistributions of source code must retain the above copyright
				notice, this list of conditions and the following disclaimer.
			</li>
			<li>
				Redistributions in binary form must reproduce the above
				copyright notice, this list of conditions and the following
				disclaimer in the documentation and/or other materials provided
				with the distribution.
			</li>
			<li>
				Neither the name of the copyright holder nor the names of its
				contributors may be used to endorse or promote products derived
				from this software without specific prior written permission.
			</li>
		</ol>
		<p>
			THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
			&quot;AS IS&quot; AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING,
			BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
			FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL
			THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
			INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
			(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
			SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
			HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
			STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
			ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
			OF THE POSSIBILITY OF SUCH DAMAGE.
		</p>
		<h2 id="jinja2">jinja2:</h2>
		<p>Copyright 2007 Pallets</p>
		<p>
			Redistribution and use in source and binary forms, with or without
			modification, are permitted provided that the following conditions
			are met:
		</p>
		<ol>
			<li>
				Redistributions of source code must retain the above copyright
				notice, this list of conditions and the following disclaimer.
			</li>
			<li>
				Redistributions in binary form must reproduce the above
				copyright notice, this list of conditions and the following
				disclaimer in the documentation and/or other materials provided
				with the distribution.
			</li>
			<li>
				Neither the name of the copyright holder nor the names of its
				contributors may be used to endorse or promote products derived
				from this software without specific prior written permission.
			</li>
		</ol>
		<p>
			THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
			&quot;AS IS&quot; AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING,
			BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
			FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL
			THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
			INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
			(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
			SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
			HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
			STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
			ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
			OF THE POSSIBILITY OF SUCH DAMAGE.
		</p>
		<h2 id="markupsafe">markupsafe:</h2>
		<h3 id="copyright--2010-pallets">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2010 Pallets
		</h3>
		<p>
			Redistribution and use in source and binary forms, with or without
			modification, are permitted provided that the following conditions
			are met:
		</p>
		<ol>
			<li>
				Redistributions of source code must retain the above copyright
				notice, this list of conditions and the following disclaimer.
			</li>
			<li>
				Redistributions in binary form must reproduce the above
				copyright notice, this list of conditions and the following
				disclaimer in the documentation and/or other materials provided
				with the distribution.
			</li>
			<li>
				Neither the name of the copyright holder nor the names of its
				contributors may be used to endorse or promote products derived
				from this software without specific prior written permission.
			</li>
		</ol>
		<p>
			THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
			&quot;AS IS&quot; AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING,
			BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
			FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL
			THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
			INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
			(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
			SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
			HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
			STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
			ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
			OF THE POSSIBILITY OF SUCH DAMAGE.
		</p>
		<h2 id="moment">moment:</h2>
		<h3 id="copyright--js-foundation-and-other-contributors">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			JS Foundation and other contributors
		</h3>
		<p>
			Permission is hereby granted, free of charge, to any person
			obtaining a copy of this software and associated documentation files
			(the &quot;Software&quot;), to deal in the Software without
			restriction, including without limitation the rights to use, copy,
			modify, merge, publish, distribute, sublicense, and/or sell copies
			of the Software, and to permit persons to whom the Software is
			furnished to do so, subject to the following conditions:
		</p>
		<p>
			The above copyright notice and this permission notice shall be
			included in all copies or substantial portions of the Software.
		</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY
			KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
			WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
			NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
			BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
			ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
			CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
			SOFTWARE.
		</p>
		<h2 id="moment-timezone">moment-timezone:</h2>
		<h3 id="copyright--js-foundation-and-other-contributors-2">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			JS Foundation and other contributors
		</h3>
		<p>
			Permission is hereby granted, free of charge, to any person
			obtaining a copy of this software and associated documentation files
			(the &quot;Software&quot;), to deal in the Software without
			restriction, including without limitation the rights to use, copy,
			modify, merge, publish, distribute, sublicense, and/or sell copies
			of the Software, and to permit persons to whom the Software is
			furnished to do so, subject to the following conditions:
		</p>
		<p>
			The above copyright notice and this permission notice shall be
			included in all copies or substantial portions of the Software.
		</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY
			KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
			WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
			NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
			BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
			ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
			CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
			SOFTWARE.
		</p>
		<h2 id="nodejs">Node.js:</h2>
		<p>Copyright Node.js contributors. All rights reserved.</p>
		<p>
			Permission is hereby granted, free of charge, to any person
			obtaining a copy of this software and associated documentation files
			(the &quot;Software&quot;), to deal in the Software without
			restriction, including without limitation the rights to use, copy,
			modify, merge, publish, distribute, sublicense, and/or sell copies
			of the Software, and to permit persons to whom the Software is
			furnished to do so, subject to the following conditions:
		</p>
		<p>
			The above copyright notice and this permission notice shall be
			included in
		</p>
		<p>all copies or substantial portions of the Software.</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY
			KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
			WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
			NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
			BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
			ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
			CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
			SOFTWARE.
		</p>
		<h2 id="node-opcua">node-opcua:</h2>
		<h3 id="copyright--2022-2023-sterfive-sas---833264583-rcs-orleans----france-httpswwwsterfivecom">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2022-2023 Sterfive SAS - 833264583 RCS ORLEANS – France (
			<a
				href="https://www.sterfive.com"
				target="_blank"
				className="url"
				rel="noopener noreferrer">
				https://www.sterfive.com
			</a>
			)
		</h3>
		<h3 id="copyright--2014-2022-etienne-rossignon">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2014-2022 Etienne Rossignon
		</h3>
		<p>
			Permission is hereby granted, free of charge, to any person
			obtaining a copy of this software and associated documentation files
			(the &quot;Software&quot;), to deal in the Software without
			restriction, including without limitation the rights to use, copy,
			modify, merge, publish, distribute, sublicense, and/or sell copies
			of the Software, and to permit persons to whom the Software is
			furnished to do so, subject to the following conditions:
		</p>
		<p>
			The above copyright notice and this permission notice shall be
			included in all copies or substantial portions of the Software.
		</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY
			KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
			WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
			NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
			BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
			ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
			CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
			SOFTWARE.
		</p>
		<h2 id="openjdk11">openjdk11:</h2>
		<p>Copyright (C) 1989, 1991 Free Software Foundation, Inc.</p>
		<p>
			Portions of OpenJDK v.11.0.13.8 are © by various parties as
			indicated in the individual source code files. This Autodesk
			software contains OpenJDK v.11.0.13.8. OpenJDK is licensed under the
			GNU General Public License v.2 with Classpath exception, which can
			be found at{' '}
			<a
				href="https://openjdk.java.net/legal/gplv2+ce.html"
				target="_blank"
				rel="noopener noreferrer">
				https://openjdk.java.net/legal/gplv2+ce.html
			</a>
			&nbsp; A text copy of this license and the source code for OpenJDK
			v.11.0.13.8 (and modifications made by Autodesk, if any) are
			included on the DVD or with the download of this Autodesk software.
			You may modify, debug and relink OpenJDK to this Autodesk software
			as provided under the terms of the GNU General Public License v.2
			with Classpath exception.
		</p>
		<h2 id="pip">pip:</h2>
		<h3 id="copyright--2018-raimon">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2018 raimon
		</h3>
		<p>
			Permission is hereby granted, free of charge, to any person
			obtaining a copy of this software and associated documentation files
			(the &quot;Software&quot;), to deal in the Software without
			restriction, including without limitation the rights to use, copy,
			modify, merge, publish, distribute, sublicense, and/or sell copies
			of the Software, and to permit persons to whom the Software is
			furnished to do so, subject to the following conditions:
		</p>
		<p>
			The above copyright notice and this permission notice shall be
			included in all copies or substantial portions of the Software.
		</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY
			KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
			WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
			NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
			BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
			ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
			CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
			SOFTWARE.
		</p>
		<h2 id="pyodbc">pyodbc:</h2>
		<p>Copyright © 2009 Michael Kleehammer</p>
		<p>
			Permission is hereby granted, free of charge, to any person
			obtaining a copy of this software and associated documentation files
			(the &quot;Software&quot;), to deal in the Software without
			restriction, including without limitation the rights to use, copy,
			modify, merge, publish, distribute, sublicense, and/or sell copies
			of the Software, and to permit persons to whom the Software is
			furnished to do so.
		</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY
			KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
			WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
			NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
			BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
			ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
			CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
			SOFTWARE.
		</p>
		<h2 id="python">Python:</h2>
		<p>
			Copyright © 2001-2022 Python Software Foundation. All Rights
			Reserved.
		</p>
		<p>
			Copyright © 2001-2022 Python Software Foundation. All Rights
			Reserved.
		</p>
		<p>
			Python software and documentation are licensed under the PSF License
			Agreement.
		</p>
		<p>
			Starting with Python 3.8.6, examples, recipes, and other code in the
			documentation are dual licensed under the PSF License Agreement and
			the Zero-Clause BSD license.Some software incorporated into Python
			is under different licenses. The licenses are listed with code
			falling under that license. See Licenses and Acknowledgements for
			Incorporated Software for an incomplete list of these licenses.
		</p>
		<h2>PSF LICENSE AGREEMENT FOR PYTHON 3.10.41.</h2>
		<ol>
			<li>
				This LICENSE AGREEMENT is between the Python Software Foundation
				(&quot;PSF&quot;), and the Individual or Organization
				(&quot;Licensee&quot;) accessing and otherwise using
				Python3.10.4 software in source or binary form and its
				associated documentation.
			</li>
			<li>
				Subject to the terms and conditions of this License Agreement,
				PSF hereby grants Licensee a nonexclusive, royalty-free,
				world-wide license to reproduce,analyze, test, perform and/or
				display publicly, prepare derivative works, distribute, and
				otherwise use Python 3.10.4 alone or in any derivative version,
				provided, however, that PSF&#39;s License Agreement and
				PSF&#39;s notice ofcopyright, i.e., &quot;Copyright © 2001-2022
				Python Software Foundation; All Rights Reserved&quot; are
				retained in Python 3.10.4 alone or in any derivative version
				prepared by Licensee.
			</li>
			<li>
				In the event Licensee prepares a derivative work that is based
				on or incorporates Python 3.10.4 or any part thereof, and wants
				to make the derivative work available to others as provided
				herein, then Licensee herebyagrees to include in any such work a
				brief summary of the changes made to Python 3.10.4.
			</li>
			<li>
				PSF is making Python 3.10.4 available to Licensee on an &quot;AS
				IS&quot; basis. PSF MAKES NO REPRESENTATIONS OR WARRANTIES,
				EXPRESS OR IMPLIED. BY WAY OFEXAMPLE, BUT NOT LIMITATION, PSF
				MAKES NO AND DISCLAIMS ANY REPRESENTATION OR WARRANTY OF
				MERCHANTABILITY OR FITNESS FOR ANY PARTICULAR PURPOSE OR THAT
				THE USE OF PYTHON 3.10.4 WILL NOT INFRINGE ANY THIRD PARTY
				RIGHTS.
			</li>
			<li>
				PSF SHALL NOT BE LIABLE TO LICENSEE OR ANY OTHER USERS OF PYTHON
				3.10.4 FOR ANY INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES OR
				LOSS AS A RESULT OFMODIFYING, DISTRIBUTING, OR OTHERWISE USING
				PYTHON 3.10.4, OR ANY DERIVATIVE THEREOF, EVEN IF ADVISED OF THE
				POSSIBILITY THEREOF.
			</li>
			<li>
				This License Agreement will automatically terminate upon a
				material breach of its terms and conditions.
			</li>
			<li>
				Nothing in this License Agreement shall be deemed to create any
				relationship of agency, partnership, or joint venture between
				PSF and Licensee. This LicenseAgreement does not grant
				permission to use PSF trademarks or trade name in a trademark
				sense to endorse or promote products or services of Licensee, or
				any third party.
			</li>
			<li>
				By copying, installing or otherwise using Python 3.10.4,
				Licensee agrees to be bound by the terms and conditions of this
				License Agreement.
			</li>
		</ol>
		<h2>BEOPEN.COM LICENSE AGREEMENT FOR PYTHON 2.0</h2>
		<h3>BEOPEN PYTHON OPEN SOURCE LICENSE AGREEMENT VERSION 1:</h3>
		<ol>
			<li>
				This LICENSE AGREEMENT is between BeOpen.com
				(&quot;BeOpen&quot;), having an office at 160 Saratoga Avenue,
				Santa Clara, CA 95051, and the Individual or
				Organization(&quot;Licensee&quot;) accessing and otherwise using
				this software in source or binary form and its associated
				documentation (&quot;the Software&quot;).
			</li>
			<li>
				Subject to the terms and conditions of this BeOpen Python
				License Agreement, BeOpen hereby grants Licensee a
				non-exclusive, royalty-free, world-wide licenseto reproduce,
				analyze, test, perform and/or display publicly, prepare
				derivative works, distribute, and otherwise use the Software
				alone or in any derivative version, provided, however, that the
				BeOpen Python License is retained in the Software, alone or in
				any derivative version prepared by Licensee.
			</li>
			<li>
				BeOpen is making the Software available to Licensee on an
				&quot;AS IS&quot; basis. BEOPEN MAKES NO REPRESENTATIONS OR
				WARRANTIES, EXPRESS OR IMPLIED. BY WAY OFEXAMPLE, BUT NOT
				LIMITATION, BEOPEN MAKES NO AND DISCLAIMS ANY REPRESENTATION OR
				WARRANTY OF MERCHANTABILITY OR FITNESS FOR ANY PARTICULAR
				PURPOSE OR THAT THE USE OF THE SOFTWARE WILL NOT INFRINGE ANY
				THIRD PARTY RIGHTS.
			</li>
			<li>
				BEOPEN SHALL NOT BE LIABLE TO LICENSEE OR ANY OTHER USERS OF THE
				SOFTWARE FOR ANY INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES
				OR LOSS AS A RESULT OF USING,MODIFYING OR DISTRIBUTING THE
				SOFTWARE, OR ANY DERIVATIVE THEREOF, EVEN IF ADVISED OF THE
				POSSIBILITY THEREOF.
			</li>
			<li>
				This License Agreement will automatically terminate upon a
				material breach of its terms and conditions.
			</li>
			<li>
				This License Agreement shall be governed by and interpreted in
				all respects by the law of the State of California, excluding
				conflict of law provisions.Nothing in this License Agreement
				shall be deemed to create any relationship of agency,
				partnership, or joint venture between BeOpen and Licensee. This
				License Agreement does not grant permission to use BeOpen
				trademarks or trade names in a trademark sense to endorse or
				promote products or services of Licensee, or any third party. As
				an exception, the &quot;BeOpen Python&quot; logos available at{' '}
				<a href="http://www.pythonlabs.com/logos.html">
					http://www.pythonlabs.com/logos.html
				</a>
				&nbsp; may be used according to the permissions granted on that
				web page.
			</li>
			<li>
				By copying, installing or otherwise using the software, Licensee
				agrees to be bound by the terms and conditions of this License
				Agreement.
			</li>
		</ol>
		<h2>CNRI LICENSE AGREEMENT FOR PYTHON 1.6.1</h2>
		<ol>
			<li>
				This LICENSE AGREEMENT is between the Corporation for National
				Research Initiatives, having an office at 1895 Preston White
				Drive, Reston, VA 20191(&quot;CNRI&quot;), and the Individual or
				Organization (&quot;Licensee&quot;) accessing and otherwise
				using Python 1.6.1 software in source or binary form and its
				associated documentation.
			</li>
			<li>
				Subject to the terms and conditions of this License Agreement,
				CNRI hereby grants Licensee a nonexclusive, royalty-free,
				world-wide license to reproduce,analyze, test, perform and/or
				display publicly, prepare derivative works, distribute, and
				otherwise use Python 1.6.1 alone or in any derivative version,
				provided, however, that CNRI&#39;s License Agreement and
				CNRI&#39;s notice of copyright,i.e., &quot;Copyright © 1995-2001
				Corporation for National Research Initiatives; All Rights
				Reserved&quot; are retained in Python 1.6.1 alone or in any
				derivative version prepared by Licensee. Alternately, in lieu of
				CNRI&#39;s License Agreement,Licensee may substitute the
				following text (omitting the quotes): &quot;Python 1.6.1 is made
				available subject to the terms and conditions in CNRI&#39;s
				LicenseAgreement. This Agreement together with Python 1.6.1 may
				be located on the internet using the following unique,
				persistent identifier (known as a handle):1895.22/101 This
				Agreement may also be obtained from a proxy server on the
				internet using the following URL:
				<a
					href="http://hdl.handle.net/1895.22/1013"
					target="_blank"
					rel="noopener noreferrer">
					http://hdl.handle.net/1895.22/1013
				</a>
			</li>
			<li>
				In the event Licensee prepares a derivative work that is based
				on or incorporates Python 1.6.1 or any part thereof, and wants
				to make the derivative work available to others as provided
				herein, then Licensee hereby agrees toinclude in any such work a
				brief summary of the changes made to Python 1.6.1.
			</li>
			<li>
				CNRI is making Python 1.6.1 available to Licensee on an &quot;AS
				IS&quot; basis. CNRI MAKES NO REPRESENTATIONS OR WARRANTIES,
				EXPRESS OR IMPLIED. BY WAY OF EXAMPLE,BUT NOT LIMITATION, CNRI
				MAKES NO AND DISCLAIMS ANY REPRESENTATION OR WARRANTY OF
				MERCHANTABILITY OR FITNESS FOR ANY PARTICULAR PURPOSE OR THAT
				THE USE OF PYTHON 1.6.1 WILL NOT INFRINGE ANY THIRD PARTY
				RIGHTS.
			</li>
			<li>
				CNRI SHALL NOT BE LIABLE TO LICENSEE OR ANY OTHER USERS OF
				PYTHON 1.6.1 FOR ANY INCIDENTAL, SPECIAL, OR CONSEQUENTIAL
				DAMAGES OR LOSS AS A RESULT OFMODIFYING, DISTRIBUTING, OR
				OTHERWISE USING PYTHON 1.6.1, OR ANY DERIVATIVE THEREOF, EVEN IF
				ADVISED OF THE POSSIBILITY THEREOF.
			</li>
			<li>
				This License Agreement will automatically terminate upon a
				material breach of its terms and conditions.
			</li>
			<li>
				This License Agreement shall be governed by the federal
				intellectual property law of the United States, including
				without limitation the federal copyrightlaw, and, to the extent
				such U.S. federal law does not apply, by the law of the
				Commonwealth of Virginia, excluding Virginia&#39;s conflict of
				law provisions. Notwithstanding the foregoing, with regard to
				derivative works based on Python 1.6.1 that incorporate
				non-separable material that was previously distributed under the
				GNU General Public License (GPL), the law of the Commonwealth
				ofVirginia shall govern this License Agreement only as to issues
				arising under or with respect to Paragraphs 4, 5, and 7 of this
				License Agreement. Nothing in this License Agreement shall be
				deemed to create any relationship of agency, partnership, or
				joint venture between CNRI and Licensee. This License Agreement
				does not grant permission to use CNRI trademarks or trade name
				in a trademark sense to endorse or promote products or services
				of Licensee, or any third party.
			</li>
			<li>
				By clicking on the &quot;ACCEPT&quot; button where indicated, or
				by copying, installing or otherwise using Python 1.6.1, Licensee
				agrees to be bound by the terms and conditions of this License
				Agreement.{' '}
			</li>
		</ol>
		<h2 id="cwi-license-agreement-for-python-090-through-12">
			CWI LICENSE AGREEMENT FOR PYTHON 0.9.0 THROUGH 1.2:
		</h2>
		<p>
			Copyright © 1991 - 1995, Stichting Mathematisch Centrum Amsterdam,
			The Netherlands. All rights reserved. Permission to use, copy,
			modify, and distribute this software and its documentation for any
			purpose and without fee is hereby granted, provided that the above
			copyright notice appear in all copies and that both that copyright
			notice and this permission notice appear in supporting
			documentation, and that the name of Stichting Mathematisch Centrum
			or CWI not be used in advertising or publicity pertaining to
			distribution of the software without specific, written prior
			permission.
		</p>
		<p>
			STICHTING MATHEMATISCH CENTRUM DISCLAIMS ALL WARRANTIES WITH REGARD
			TO THIS SOFTWARE, INCLUDING ALL IMPLIED WARRANTIES OF
			MERCHANTABILITY AND FITNESS, IN NO EVENT SHALL STICHTING
			MATHEMATISCH CENTRUM BE LIABLE FOR ANY SPECIAL, INDIRECT OR
			CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS
			OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT,
			NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION
			WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
		</p>
		<p>
			ZERO-CLAUSE BSD LICENSE FOR CODE IN THE PYTHON 3.10.4
			DOCUMENTATIONPermission to use, copy, modify, and/or distribute this
			software for any purpose with or without fee is hereby granted.
		</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot; AND THE AUTHOR DISCLAIMS
			ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED
			WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE
			AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL
			DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA
			OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER
			TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
			PERFORMANCE OF THIS SOFTWARE.
		</p>
		<p>Licenses and Acknowledgements for Incorporated Software</p>
		<p>
			This section is an incomplete, but growing list of licenses and
			acknowledgements for third-party software incorporated in the Python
			distribution.
		</p>
		<p>Mersenne Twister</p>
		<p>
			{'The _random module includes code based on a download from '}
			<a
				href="http://www.math.sci.hiroshima-u.ac.jp/~m-mat/MT/MT2002/emt19937ar.html"
				target="_blank"
				rel="noopener noreferrer">
				http://www.math.sci.hiroshima-u.ac.jp/~m-mat/MT/MT2002/emt19937ar.html
			</a>
			&nbsp; The following are the verbatim comments from the original
			code:
		</p>
		<p>A C-program for MT19937, with initialization improved 2002/1/26.</p>
		<p>Coded by Takuji Nishimura and Makoto Matsumoto.</p>
		<p>Before using, initialize the state by using init_genrand(seed)</p>
		<p>or init_by_array(init_key, key_length).</p>
		<p>
			Copyright (C) 1997 - 2002, Makoto Matsumoto and Takuji Nishimura,
			All rights reserved.
		</p>
		<p>
			Redistribution and use in source and binary forms, with or without
			modification, are permitted provided that the following conditions
			are met:
		</p>
		<ol>
			<li>
				Redistributions of source code must retain the above copyright
				notice, this list of conditions and the following disclaimer.
			</li>
			<li>
				Redistributions in binary form must reproduce the above
				copyright notice, this list of conditions and the following
				disclaimer in thedocumentation and/or other materials provided
				with the distribution.
			</li>
			<li>
				The names of its contributors may not be used to endorse or
				promote products derived from this software without specific
				prior writtenpermission.
			</li>
		</ol>
		<p>
			THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
			&quot;AS IS&quot; AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING,
			BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
			FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL
			THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
			INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
			(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
			SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
			HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
			STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
			ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
			OF THE POSSIBILITY OF SUCH DAMAGE.
		</p>
		<p>Any feedback is very welcome.</p>
		<p>
			<a
				href="http://www.math.sci.hiroshima-u.ac.jp/~m-mat/MT/emt.html"
				target="_blank"
				rel="noopener noreferrer">
				http://www.math.sci.hiroshima-u.ac.jp/~m-mat/MT/emt.html
			</a>
			&nbsp;
		</p>
		<p>email: m-mat@math.sci.hiroshima-u.ac.jp</p>
		<p>Sockets</p>
		<p>
			The socket module uses the functions, getaddrinfo(), and
			getnameinfo(), which are coded in separate source files from the
			WIDE Project,{' '}
			<a
				href="http://www.wide.ad.jp/."
				target="_blank"
				rel="noopener noreferrer">
				http://www.wide.ad.jp/.
			</a>
			&nbsp;
		</p>
		<p>Copyright (C) 1995, 1996, 1997, and 1998 WIDE Project.</p>
		<p>All rights reserved.</p>
		<p>
			Redistribution and use in source and binary forms, with or without
			modification, are permitted provided that the following conditions
			are met:
		</p>
		<ol>
			<li>
				Redistributions of source code must retain the above copyright
				notice, this list of conditions and the following disclaimer.
			</li>
			<li>
				Redistributions in binary form must reproduce the above
				copyright notice, this list of conditions and the following
				disclaimer in thedocumentation and/or other materials provided
				with the distribution.
			</li>
			<li>
				Neither the name of the project nor the names of its
				contributors may be used to endorse or promote products derived
				from this softwarewithout specific prior written permission.
			</li>
		</ol>
		<p>
			THIS SOFTWARE IS PROVIDED BY THE PROJECT AND CONTRIBUTORS &quot;AS
			IS&quot; AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
			LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
			FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
			PROJECT OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
			INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
			BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
			LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
			CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
			LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
			ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
			POSSIBILITY OF SUCH DAMAGE.
		</p>
		<p>Asynchronous socket services</p>
		<p>The asynchat and asyncore modules contain the following notice:</p>
		<p>Copyright 1996 by Sam Rushing All Rights Reserved</p>
		<p>
			Permission to use, copy, modify, and distribute this software and
			its documentation for any purpose and without fee is hereby granted,
			provided that the above copyright notice appear in all copies and
			that both that copyright notice and this permission notice appear in
			supporting documentation, and that the name of Sam Rushing not be
			used in advertising or publicity pertaining to distribution of the
			software without specific, written prior permission.
		</p>
		<p>
			SAM RUSHING DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE,
			INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS, IN
			NO EVENT SHALL SAM RUSHING BE LIABLE FOR ANY SPECIAL, INDIRECT OR
			CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS
			OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT,
			NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION
			WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
		</p>
		<p>Cookie management</p>
		<p>The http.cookies module contains the following notice:</p>
		<p>
			Copyright 2000 by Timothy O&apos;Malley &lt;
			<a
				href="mailto:timo@alum.mit.edu"
				target="_blank"
				className="url"
				rel="noopener noreferrer">
				timo@alum.mit.edu
			</a>
			&gt;
		</p>
		<p>All Rights Reserved</p>
		<p>
			Permission to use, copy, modify, and distribute this software and
			its documentation for any purpose and without fee is hereby granted,
			provided that the above copyright notice appear in all copies and
			that both that copyright notice and this permission notice appear in
			supporting documentation, and that the name of Timothy O&apos;Malley
			not be used in advertising or publicity pertaining to distribution
			of the software without specific, written prior permission.
		</p>
		<p>
			Timothy O&apos;Malley DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS
			SOFTWARE, INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND
			FITNESS, IN NO EVENT SHALL Timothy O&apos;Malley BE LIABLE FOR ANY
			SPECIAL, INDIRECT OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER
			RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF
			CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN
			CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
		</p>
		<p>Execution tracing</p>
		<p>The trace module contains the following notice:</p>
		<p>
			portions copyright 2001, Autonomous Zones Industries, Inc., all
			rights reserved and offered to the public under the terms of the
			Python 2.2 license.Author: Zooko O&apos;Whielacronx{' '}
			<a
				href="mailto:zooko@zooko.com"
				target="_blank"
				className="url"
				rel="noopener noreferrer">
				zooko@zooko.com
			</a>
		</p>
		<p>Copyright 2000, Mojam Media, Inc., all rights reserved.</p>
		<p>Author: Skip Montanaro</p>
		<p>Copyright 1999, Bioreason, Inc., all rights reserved.</p>
		<p>Author: Andrew Dalke</p>
		<p>Copyright 1995-1997, Automatrix, Inc., all rights reserved.</p>
		<p>Author: Skip Montanaro</p>
		<p>
			Copyright 1991-1995, Stichting Mathematisch Centrum, all rights
			reserved.
		</p>
		<p>
			Permission to use, copy, modify, and distribute this Python software
			and its associated documentation for any purpose without fee is
			hereby granted, provided that the above copyright notice appears in
			all copies, and that both that copyright notice and this permission
			notice appear in supporting documentation, and that the name of
			neither Automatrix, Bioreason or Mojam Media be used in advertising
			or publicity pertaining to distribution of the software without
			specific, written prior permission.
		</p>
		<p>
			UUencode and UUdecode functions The uu module contains the following
			notice: Copyright 1994 by Lance Ellinghouse Cathedral City,
			California Republic, United States of America.
		</p>
		<p>All Rights Reserved</p>
		<p>
			Permission to use, copy, modify, and distribute this software and
			its documentation for any purpose and without fee is hereby granted,
			provided that the above copyright notice appear in all copies and
			that both that copyright notice and this permission notice appear in
			supporting documentation, and that the name of Lance Ellinghouse not
			be used in advertising or publicity pertaining to distribution of
			the software without specific, written prior permission.
		</p>
		<p>
			LANCE ELLINGHOUSE DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS
			SOFTWARE, INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND
			FITNESS, IN NO EVENT SHALL LANCE ELLINGHOUSE CENTRUM BE LIABLE FOR
			ANY SPECIAL, INDIRECT OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
			WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN
			AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING
			OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS
			SOFTWARE.
		</p>
		<p>Modified by Jack Jansen, CWI, July 1995:</p>
		<p>- Use binascii module to do the actual line-by-line conversion</p>
		<p>
			between ascii and binary. This results in a 1000-fold speedup. The C
			version is still 5 times faster, though.
		</p>
		<p>- Arguments more compliant with Python standard</p>
		<p>XML Remote Procedure Calls</p>
		<p>The xmlrpc.client module contains the following notice:</p>
		<p>The XML-RPC client interface is</p>
		<ul></ul>
		<li>
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			1999-2002 by Secret Labs AB
		</li>
		<li>
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			1999-2002 by Fredrik Lundh
		</li>
		<p>
			By obtaining, using, and/or copying this software and/or its
			associated documentation, you agree that you have read, understood,
			and will comply with the following terms and conditions:
		</p>
		<p>
			Permission to use, copy, modify, and distribute this software and
			its associated documentation for any purpose and without fee is
			hereby granted, provided that the above copyright notice appears in
			all copies, and that both that copyright notice and this permission
			notice appear in supporting documentation, and that the name of
			Secret Labs AB or the author not be used in advertising or publicity
			pertaining to distribution of the software without specific, written
			prior permission.
		</p>
		<p>
			SECRET LABS AB AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH REGARD
			TO THIS SOFTWARE, INCLUDING ALL IMPLIED WARRANTIES OF
			MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL SECRET LABS AB OR THE
			AUTHOR BE LIABLE FOR ANY SPECIAL, INDIRECT OR CONSEQUENTIAL DAMAGES
			OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR
			PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER
			TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
			PERFORMANCE OF THIS SOFTWARE.
		</p>
		<p>test_epoll</p>
		<p>The test_epoll module contains the following notice:</p>
		<h3 id="copyright--2001-2006-twisted-matrix-laboratories">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2001-2006 Twisted Matrix Laboratories.
		</h3>
		<p>
			Permission is hereby granted, free of charge, to any person
			obtaining a copy of this software and associated documentation files
			(the &quot;Software&quot;), to deal in the Software without
			restriction, including without limitation the rights to use, copy,
			modify, merge, publish, distribute, sublicense, and/or sell copies
			of the Software, and to permit persons to whom the Software is
			furnished to do so, subject to the following conditions:
		</p>
		<p>
			The above copyright notice and this permission notice shall be
			included in all copies or substantial portions of the Software.
		</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY
			KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
			WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
			NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
			BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
			ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
			CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
			SOFTWARE.
		</p>
		<h2 id="select-kqueue">Select kqueue</h2>
		<p>
			The select module contains the following notice for the kqueue
			interface:
		</p>
		<h3 id="copyright--2000-doug-white-2006-james-knight-2007-christian-heimes">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2000 Doug White, 2006 James Knight, 2007 Christian Heimes
		</h3>
		<p>All rights reserved.</p>
		<p>
			Redistribution and use in source and binary forms, with or without
			modification, are permitted provided that the following conditions
			are met:
		</p>
		<ol>
			<li>
				Redistributions of source code must retain the above copyright
				notice, this list of conditions and the following disclaimer.
			</li>
			<li>
				Redistributions in binary form must reproduce the above
				copyright notice, this list of conditions and the following
				disclaimer in thedocumentation and/or other materials provided
				with the distribution.
			</li>
		</ol>
		<p>
			THIS SOFTWARE IS PROVIDED BY THE AUTHOR AND CONTRIBUTORS &quot;AS
			IS&quot; AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
			LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
			FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
			AUTHOR OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
			INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
			BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
			LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
			CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
			LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
			ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
			POSSIBILITY OF SUCH DAMAGE.
		</p>
		<p>SipHash24</p>
		<p>
			The file Python/pyhash.c contains Marek Majkowski’ implementation of
			Dan Bernstein’s SipHash24 algorithm. It contains the following note:
		</p>
		<p>&lt;MIT License&gt;</p>
		<p>
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2013 Marek Majkowski &lt;
			<a
				href="mailto:marek@popcount.org"
				target="_blank"
				className="url"
				rel="noopener noreferrer">
				marek@popcount.org
			</a>
			&gt;
		</p>
		<p>
			Permission is hereby granted, free of charge, to any person
			obtaining a copy of this software and associated documentation files
			(the &quot;Software&quot;), to deal in the Software without
			restriction, including without limitation the rights to use, copy,
			modify, merge, publish, distribute, sublicense, and/or sell copies
			of the Software, and to permit persons to whom the Software is
			furnished to do so, subject to the following conditions:
		</p>
		<p>
			The above copyright notice and this permission notice shall be
			included in all copies or substantial portions of the Software.
		</p>
		<p>&lt;/MIT License&gt;</p>
		<p>Original location:</p>
		<p>
			<a
				href="https://github.com/majek/csiphash/"
				target="_blank"
				rel="noopener noreferrer">
				https://github.com/majek/csiphash/
			</a>
			&nbsp;
		</p>
		<p>Solution inspired by code from:</p>
		<p>
			Samuel Neves (supercop/crypto_auth/siphash24/little) djb
			(supercop/crypto_auth/siphash24/little2) Jean-Philippe Aumasson (
			<a
				href="https://131002.net/siphash/siphash24.c)strtod"
				target="_blank"
				className="url"
				rel="noopener noreferrer">
				https://131002.net/siphash/siphash24.c)strtod
			</a>{' '}
			and dtoa
		</p>
		<p>
			The file Python/dtoa.c, which supplies C functions dtoa and strtod
			for conversion of C doubles to and from strings, is derived from the
			file of the same name by David M. Gay, currently available from{' '}
			<a
				href="http://www.netlib.org/fp/."
				target="_blank"
				rel="noopener noreferrer">
				http://www.netlib.org/fp/.
			</a>
			&nbsp; The original file, as retrieved on March 16, 2009, contains
			the following copyright and licensing notice:
		</p>
		<p>
			The author of this software is David M. Gay. Copyright
			<span role="img" aria-label="copyright">
				{' ©️ '}
			</span>
			1991, 2000, 2001 by Lucent Technologies.
		</p>
		<p>
			Permission to use, copy, modify, and distribute this software for
			any purpose without fee is hereby granted, provided that this entire
			notice is included in all copies of any software which is or
			includes a copy or modification of this software and in all copies
			of the supporting documentation for such software.
		</p>
		<p>
			THIS SOFTWARE IS BEING PROVIDED &quot;AS IS&quot;, WITHOUT ANY
			EXPRESS OR IMPLIED * WARRANTY. IN PARTICULAR, NEITHER THE AUTHOR NOR
			LUCENT MAKES ANY * REPRESENTATION OR WARRANTY OF ANY KIND CONCERNING
			THE MERCHANTABILITY * OF THIS SOFTWARE OR ITS FITNESS FOR ANY
			PARTICULAR PURPOSE.
		</p>

		<h2 id="openssl">OpenSSL</h2>
		<p>
			The modules hashlib, posix, ssl, crypt use the OpenSSL library for
			added performance if made available by the operating system.
			Additionally, the Windows and macOS installers for Python may
			include a copy of the OpenSSL libraries, so we include a copy of the
			OpenSSL license here:
		</p>
		<p>LICENSE ISSUES ==============</p>
		<p>
			The OpenSSL toolkit stays under a dual license, i.e. both the
			conditions of the OpenSSL License and the original SSLeay license
			apply to the toolkit. See below for the actual license texts.
			Actually both licenses are BSD-style Open Source licenses. In case
			of any license issues related to OpenSSL please contact{' '}
			<a
				href="mailto:openssl-core@openssl.org"
				target="_blank"
				className="url"
				rel="noopener noreferrer">
				openssl-core@openssl.org
			</a>
			.
		</p>

		<h3 id="openssl-license">OpenSSL License</h3>
		<p>
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			1998-2008 The OpenSSL Project. All rights reserved.
		</p>
		<p>
			Redistribution and use in source and binary forms, with or without
			modification, are permitted provided that the following conditions
			are met:
		</p>
		<ol>
			<li>
				Redistributions of source code must retain the above copyright
				notice, this list of conditions, and the following disclaimer.
			</li>
			<li>
				Redistributions in binary form must reproduce the above
				copyright notice, this list of conditions, and the following
				disclaimer in the documentation and/or other materials provided
				with the distribution.
			</li>
			<li>
				All advertising materials mentioning features or use of this
				software must display the following acknowledgment: &quot;This
				product includes software developed by the OpenSSL Project for
				use in the OpenSSL Toolkit. (
				<a
					href="http://www.openssl.org/"
					target="_blank"
					className="url"
					rel="noopener noreferrer">
					http://www.openssl.org/
				</a>
				)&quot;
			</li>
			<li>
				The names &quot;OpenSSL Toolkit&quot; and &quot;OpenSSL
				Project&quot; must not be used to endorse or promote products
				derived from this software without prior written permission. For
				written permission, please contact{' '}
				<a
					href="mailto:openssl-core@openssl.org"
					target="_blank"
					rel="noopener noreferrer">
					openssl-core@openssl.org
				</a>
				.
			</li>
			<li>
				Products derived from this software may not be called
				&quot;OpenSSL&quot; nor may &quot;OpenSSL&quot; appear in their
				names without prior written permission of the OpenSSL Project.
			</li>
			<li>
				Redistributions of any form whatsoever must retain the following
				acknowledgment: &quot;This product includes software developed
				by the OpenSSL Project for use in the OpenSSL Toolkit (
				<a
					href="http://www.openssl.org/"
					target="_blank"
					className="url"
					rel="noopener noreferrer">
					http://www.openssl.org/
				</a>
				)&quot;
			</li>
		</ol>
		<p>
			THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT &quot;AS IS&quot;
			AND ANY EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED
			TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
			PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE OpenSSL
			PROJECT OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
			INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
			BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
			LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION), HOWEVER
			CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
			LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
			ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
			POSSIBILITY OF SUCH DAMAGE.
		</p>
		<p>
			This product includes cryptographic software written by Eric Young (
			<a
				href="mailto:eay@cryptsoft.com"
				target="_blank"
				rel="noopener noreferrer">
				eay@cryptsoft.com
			</a>
			). This product includes software written by Tim Hudson (
			<a
				href="mailto:tjh@cryptsoft.com"
				target="_blank"
				rel="noopener noreferrer">
				tjh@cryptsoft.com
			</a>
			).
		</p>
		<h3 id="original-ssleay-license">Original SSLeay License</h3>
		<p>
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			1995-1998 Eric Young (
			<a
				href="mailto:eay@cryptsoft.com"
				target="_blank"
				rel="noopener noreferrer">
				eay@cryptsoft.com
			</a>
			) All rights reserved.
		</p>
		<p>
			This package is an SSL implementation written by Eric Young (
			<a
				href="mailto:eay@cryptsoft.com"
				target="_blank"
				rel="noopener noreferrer">
				eay@cryptsoft.com
			</a>
			). The implementation was written so as to conform with Netscapes
			SSL.
		</p>
		<p>
			This library is free for commercial and non-commercial use as long
			as the following conditions are adhered to. The following conditions
			apply to all code found in this distribution, be it the RC4, RSA,
			lhash, DES, etc., code; not just the SSL code. The SSL documentation
			included with this distribution is covered by the same copyright
			terms except that the holder is Tim Hudson (
			<a
				href="mailto:tjh@cryptsoft.com"
				target="_blank"
				rel="noopener noreferrer">
				tjh@cryptsoft.com
			</a>
			).
		</p>
		<p>
			Copyright remains Eric Young&#39;s, and as such any Copyright
			notices in the code are not to be removed. If this package is used
			in a product, Eric Young should be given attribution as the author
			of the parts of the library used. This can be in the form of a
			textual message at program startup or in documentation (online or
			textual) provided with the package.
		</p>
		<p>
			Redistribution and use in source and binary forms, with or without
			modification, are permitted provided that the following conditions
			are met:
		</p>
		<ol>
			<li>
				Redistributions of source code must retain the copyright notice,
				this list of conditions, and the following disclaimer.
			</li>
			<li>
				Redistributions in binary form must reproduce the above
				copyright notice, this list of conditions, and the following
				disclaimer in the documentation and/or other materials provided
				with the distribution.
			</li>
			<li>
				All advertising materials mentioning features or use of this
				software must display the following acknowledgment: &quot;This
				product includes cryptographic software written by Eric Young (
				<a
					href="mailto:eay@cryptsoft.com"
					target="_blank"
					rel="noopener noreferrer">
					eay@cryptsoft.com
				</a>
				)&quot;. The word &#39;cryptographic&#39; can be left out if the
				routines from the library being used are not cryptographic
				related :-).
			</li>
			<li>
				If you include any Windows specific code (or a derivative
				thereof) from the apps directory (application code), you must
				include an acknowledgment: &quot;This product includes software
				written by Tim Hudson (
				<a
					href="mailto:tjh@cryptsoft.com"
					target="_blank"
					rel="noopener noreferrer">
					tjh@cryptsoft.com
				</a>
				)&quot;
			</li>
		</ol>
		<p>
			THIS SOFTWARE IS PROVIDED BY ERIC YOUNG &quot;AS IS&quot; AND ANY
			EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
			IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
			PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE AUTHOR OR CONTRIBUTORS
			BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY,
			OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
			OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
			BUSINESS INTERRUPTION), HOWEVER CAUSED AND ON ANY THEORY OF
			LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
			NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
			SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
		</p>
		<p>
			The license and distribution terms for any publicly available
			version or derivative of this code cannot be changed. i.e. this code
			cannot simply be copied and put under another distribution license
			[including the GNU Public License.]
		</p>
		<h2 id="esri">Esri:</h2>
		<p>
			Copyright &copy; 2024 Esri and its licensors. All rights reserved.
			Esri, ArcGIS, esri.com, arcgis.com, the Powered by Esri icon, and
			the Esri globe logo are trademarks, service marks, or registered
			marks of Esri in the United States, the European Community, or
			certain other jurisdictions. Other companies and products or
			services mentioned herein may be trademarks, service marks, or
			registered marks of their respective mark owners.
		</p>
		<h2 id="expat">expat</h2>
		<p>
			Permission is hereby granted, free of charge, to any person
			obtaining a copy of this software and associated documentation files
			(the &quot;Software&quot;), to deal in the Software without
			restriction, including without limitation the rights to use, copy,
			modify, merge, publish, distribute, sublicense, and/or sell copies
			of the Software, and to permit persons to whom the Software is
			furnished to do so, subject to the following conditions:
		</p>
		<p>
			The above copyright notice and this permission notice shall be
			included in all copies or substantial portions of the Software.
		</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY
			KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
			WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
			NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
			BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
			ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
			CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
			SOFTWARE.
		</p>
		<p>
			libffi The <code>_ctypes</code> extension is built using an included
			copy of the libffi sources unless the build is configured{' '}
			<code>--with-system-libffi</code>:
		</p>
		<h3 id="copyright--1996-2008-red-hat-inc-and-others">
			Copyright
			<span role="img" aria-label="copyright">
				{' ©️ '}
			</span>
			1996-2008 Red Hat, Inc and others.
		</h3>
		<p>
			Permission is hereby granted, free of charge, to any person
			obtaining a copy of this software and associated documentation files
			(the &quot;Software&quot;), to deal in the Software without
			restriction, including without limitation the rights to use, copy,
			modify, merge, publish, distribute, sublicense, and/or sell copies
			of the Software, and to permit persons to whom the Software is
			furnished to do so, subject to the following conditions:
		</p>
		<p>
			The above copyright notice and this permission notice shall be
			included
		</p>
		<p>in all copies or substantial portions of the Software.</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY
			KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
			WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
			NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
			BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
			ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
			CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
			SOFTWARE.
		</p>
		<h2 id="zlib">zlib:</h2>
		<p>
			The zlib extension is built using an included copy of the zlib
			sources if the zlib version found on the system is too old to be
			used for the build:
		</p>
		<p>
			Copyright (C) 1995-2011 Jean-loup Gailly and Mark Adler This
			software is provided &apos;as-is&apos;, without any express or
			implied warranty. In no event will the authors be held liable for
			any damages arising from the use of this software.
		</p>
		<p>
			Permission is granted to anyone to use this software for any
			purpose, including commercial applications, and to alter it and
			redistribute it freely, subject to the following restrictions:
		</p>
		<ol>
			<li>
				The origin of this software must not be misrepresented; you must
				not claim that you wrote the original software. If you use this
				softwarein a product, an acknowledgment in the product
				documentation would be appreciated but is not required.
			</li>
			<li>
				Altered source versions must be plainly marked as such, and must
				not be misrepresented as being the original software.
			</li>
			<li>
				This notice may not be removed or altered from any source
				distribution. Jean-loup (
				<a
					href="mailto:jloup@gzip.org"
					target="_blank"
					className="url"
					rel="noopener noreferrer">
					jloup@gzip.org
				</a>
				) Gailly Mark Adler (
				<a
					href="mailto:madler@alumni.caltech.edu"
					target="_blank"
					className="url"
					rel="noopener noreferrer">
					madler@alumni.caltech.edu
				</a>
				)
			</li>
		</ol>
		<p>cfuhash</p>
		<p>
			The implementation of the hash table used by the tracemalloc is
			based on the cfuhash project:
		</p>
		<h3 id="copyright--2005-don-owens">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2005 Don Owens
		</h3>
		<p>All rights reserved.</p>
		<p>This code is released under the BSD license:</p>
		<p>
			Redistribution and use in source and binary forms, with or without
			modification, are permitted provided that the following conditions
			are met:
		</p>
		<ul>
			<li>
				Redistributions of source code must retain the above copyright
				notice, this list of conditions and the following disclaimer.
			</li>
			<li>
				Redistributions in binary form must reproduce the above
				copyright notice, this list of conditions and the following
				disclaimer in the documentation and/or other materials provided
				with the distribution.
			</li>
			<li>
				Neither the name of the author nor the names of its contributors
				may be used to endorse or promote products derived from this
				software without specific prior written permission.
			</li>
		</ul>
		<p>
			THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
			&quot;AS IS&quot; AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING,
			BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
			FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL
			THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
			INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
			(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
			SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
			HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
			STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
			ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
			OF THE POSSIBILITY OF SUCH DAMAGE.
		</p>
		<h3 id="libmpdec">libmpdec</h3>
		<p>
			The _decimal module is built using an included copy of the libmpdec
			library unless the build is configured --with-system-libmpdec:
		</p>
		<h3 id="copyright--2008-2020-stefan-krah-all-rights-reserved">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2008-2020 Stefan Krah. All rights reserved.
		</h3>
		<p>
			Redistribution and use in source and binary forms, with or without
			modification, are permitted provided that the following conditions
			are met:
		</p>
		<ol>
			<li>
				Redistributions of source code must retain the above copyright
				notice, this list of conditions and the following disclaimer.
			</li>
			<li>
				Redistributions in binary form must reproduce the above
				copyright notice, this list of conditions and the following
				disclaimer in the documentation and/or other materials provided
				with the distribution.
			</li>
		</ol>
		<p>
			THIS SOFTWARE IS PROVIDED BY THE AUTHOR AND CONTRIBUTORS &quot;AS
			IS&quot; AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
			LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
			FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
			AUTHOR OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
			INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
			BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
			LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
			CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
			LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
			ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
			POSSIBILITY OF SUCH DAMAGE.
		</p>
		<h3>W3C C14N test suite</h3>
		<p>
			The C14N 2.0 test suite in the test package
			(Lib/test/xmltestdata/c14n-20/) was retrieved from the W3C website
			at{' '}
			<a
				href="https://www.w3.org/TR/xml-c14n2-testcases/"
				target="_blank"
				rel="noopener noreferrer">
				https://www.w3.org/TR/xml-c14n2-testcases/
			</a>
			&nbsp; and is distributed under the 3-clause BSD license:Copyright
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2013 W3C(R) (MIT, ERCIM, Keio, Beihang),
		</p>
		<p>All Rights Reserved.</p>
		<p>
			Redistribution and use in source and binary forms, with or without
			modification, are permitted provided that the following conditions
			are met:
		</p>

		<ul>
			<li>
				Redistributions of works must retain the original copyright
				notice, this list of conditions and the following disclaimer.
			</li>
			<li>
				Redistributions in binary form must reproduce the original
				copyright notice, this list of conditions and the following
				disclaimer in the documentation and/or other materials provided
				with the distribution.
			</li>
			<li>
				Neither the name of the W3C nor the names of its contributors
				may be used to endorse or promote products derived from this
				work without specific prior written permission.
			</li>
		</ul>

		<p>
			THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
			&quot;AS IS&quot; AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING,
			BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
			FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL
			THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
			INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
			(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
			SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
			HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
			STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
			ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
			OF THE POSSIBILITY OF SUCH DAMAGE.
		</p>
		<h2 id="pytz">pytz:</h2>
		<h3 id="copyright--2003-2019-stuart-bishop-stuartstuartbishopnet">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2003-2019 Stuart Bishop{' '}
			<a
				href="mailto:stuart@stuartbishop.net"
				target="_blank"
				rel="noopener noreferrer">
				stuart@stuartbishop.net
			</a>
		</h3>
		<p>
			Permission is hereby granted, free of charge, to any person
			obtaining a copy of this software and associated documentation files
			(the &quot;Software&quot;), to deal in the Software without
			restriction, including without limitation the rights to use, copy,
			modify, merge, publish, distribute, sublicense, and/or sell copies
			of the Software, and to permit persons to whom the Software is
			furnished to do so, subject to the following conditions:
		</p>
		<p>
			The above copyright notice and this permission notice shall be
			included in all copies or substantial portions of the Software.
		</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY
			KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
			WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
			NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
			BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
			ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
			CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
			SOFTWARE.
		</p>
		<h2 id="redis">redis:</h2>
		<h3 id="copyright--2006-2015-salvatore-sanfilippo">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2006-2015, Salvatore Sanfilippo
		</h3>
		<p>
			Modifications copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			Microsoft Open Technologies, Inc.
		</p>
		<p>All rights reserved.</p>
		<p>
			Redistribution and use in source and binary forms, with or without
			modification, are permitted provided that the following conditions
			are met:
		</p>
		<ol>
			<li>
				Redistributions of source code must retain the above copyright
				notice, this list of conditions and the following disclaimer.
			</li>
			<li>
				Redistributions in binary form must reproduce the above
				copyright notice, this list of conditions and the following
				disclaimer in the documentationand/or other materials provided
				with the distribution.
			</li>
			<li>
				Neither the name of the copyright holder nor the names of its
				contributors may be used to endorse or promote products derived
				from this softwarewithout specific prior written permission.
			</li>
		</ol>
		<p>
			THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
			&quot;AS IS&quot; AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING,
			BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
			FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL
			THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
			INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
			(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
			SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
			HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
			STRICT LIABILITY,
		</p>
		<p>
			OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT
			OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
			SUCH DAMAGE.
		</p>
		<h2 id="redis-sdk">redis (sdk)</h2>
		<h3 id="copyright--2016-present-node-redis-contributors">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2016-present Node Redis contributors.
		</h3>
		<p>
			Permission is hereby granted, free of charge, to any person
			obtaining a copy of this software and associated documentation files
			(the &quot;Software&quot;), to deal in the Software without
			restriction, including without limitation the rights to use, copy,
			modify, merge, publish, distribute, sublicense, and/or sell copies
			of the Software, and to permit persons to whom the Software is
			furnished to do so, subject to the following conditions:
		</p>
		<p>
			The above copyright notice and this permission notice shall be
			included in all copies or substantial portions of the Software.
		</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY
			KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
			WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
			NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
			BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
			ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
			CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
			SOFTWARE.
		</p>
		<h2 id="requests">requests:</h2>
		<p>Copyright 2019 Kenneth Reitz</p>
		<p>
			Licensed under the Apache License, Version 2.0 (the
			&quot;License&quot;); you may not use this file except in compliance
			with the License. You may obtain a copy of the License at{' '}
			<a
				href="http://www.apache.org/licenses/LICENSE-2.0"
				target="_blank"
				rel="noopener noreferrer">
				http://www.apache.org/licenses/LICENSE-2.0
			</a>
			&nbsp;
		</p>
		<p>
			Unless required by applicable law or agreed to in writing, software
			distributed under the License is distributed on an &quot;AS IS&quot;
			BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
			or implied. See the License for the specific language governing
			permissions and limitations under the License.
		</p>
		<h2 id="setuptools">setuptools:</h2>
		<p>Copyright Jason R. Coombs</p>
		<p>
			Permission is hereby granted, free of charge, to any person
			obtaining a copy of this software and associated documentation files
			(the &quot;Software&quot;), to deal in the Software without
			restriction, including without limitation the rights to use, copy,
			modify, merge, publish, distribute, sublicense, and/or sell copies
			of the Software, and to permit persons to whom the Software is
			furnished to do so, subject to the following conditions:
		</p>
		<p>
			The above copyright notice and this permission notice shall be
			included in all copies or substantial portions of the Software.
		</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY
			KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
			WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
			NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
			BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
			ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
			CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
			SOFTWARE.
		</p>
		<h2 id="six">six:</h2>
		<h3 id="copyright--2010-2020-benjamin-peterson">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2010-2020 Benjamin Peterson
		</h3>
		<p>
			Permission is hereby granted, free of charge, to any person
			obtaining a copy of this software and associated documentation files
			(the &quot;Software&quot;), to deal in the Software without
			restriction, including without limitation the rights to use, copy,
			modify, merge, publish, distribute, sublicense, and/or sell copies
			of the Software, and to permit persons to whom the Software is
			furnished to do so, subject to the following conditions:
		</p>
		<p>
			The above copyright notice and this permission notice shall be
			included in all copies or substantial portions of the Software.
		</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY
			KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
			WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
			NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
			BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
			ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
			CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
			SOFTWARE.
		</p>
		<h2 id="source-map-support">source-map-support:</h2>
		<h3 id="copyright--2014-evan-wallace">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2014 Evan Wallace
		</h3>
		<p>
			Permission is hereby granted, free of charge, to any person
			obtaining a copy of this software and associated documentation files
			(the &quot;Software&quot;), to deal in the Software without
			restriction, including without limitation the rights to use, copy,
			modify, merge, publish, distribute, sublicense, and/or sell copies
			of the Software, and to permit persons to whom the Software is
			furnished to do so, subject to the following conditions:
		</p>
		<p>
			The above copyright notice and this permission notice shall be
			included in all copies or substantial portions of the Software.
		</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY
			KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
			WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
			NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
			BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
			ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
			CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
			SOFTWARE.
		</p>
		<h2 id="tslog">tslog:</h2>
		<h3 id="copyright--2020">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2020
		</h3>
		<p>
			Permission is hereby granted, free of charge, to any person
			obtaining a copy of this software and associated documentation files
			(the &quot;Software&quot;), to deal in the Software without
			restriction, including without limitation the rights to use, copy,
			modify, merge, publish, distribute, sublicense, and/or sell copies
			of the Software, and to permit persons to whom the Software is
			furnished to do so, subject to the following conditions:
		</p>
		<p>
			The above copyright notice and this permission notice shall be
			included in all copies or substantial portions of the Software.
		</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY
			KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
			WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
			NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
			BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
			ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
			CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
			SOFTWARE.
		</p>
		<h2 id="urllib3">urllib3:</h2>
		<h3 id="copyright--2008---2020-Andrey-Petrov-and-contributors">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			2008-2020 Andrey Petrov and contributors.
		</h3>
		<p>
			Permission is hereby granted, free of charge, to any person
			obtaining a copy of this software and associated documentation files
			(the &quot;Software&quot;), to deal in the Software without
			restriction, including without limitation the rights to use, copy,
			modify, merge, publish, distribute, sublicense, and/or sell copies
			of the Software, and to permit persons to whom the Software is
			furnished to do so, subject to the following conditions:
		</p>
		<p>
			The above copyright notice and this permission notice shall be
			included in all copies or substantial portions of the Software.
		</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY
			KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
			WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
			NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
			BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
			ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
			CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
			SOFTWARE.
		</p>
		<h2 id="werkzeug">werkzeug:</h2>
		<p>Copyright 2007 Pallets</p>
		<p>
			Redistribution and use in source and binary forms, with or without
			modification, are permitted provided that the following conditions
			are met:
		</p>
		<ol>
			<li>
				Redistributions of source code must retain the above copyright
				notice, this list of conditions and the following disclaimer.
			</li>
			<li>
				Redistributions in binary form must reproduce the above
				copyright notice, this list of conditions and the following
				disclaimer in the documentation and/or other materials provided
				with the distribution.
			</li>
			<li>
				Neither the name of the copyright holder nor the names of its
				contributors may be used to endorse or promote products derived
				from this software without specific prior written permission.
			</li>
		</ol>
		<p>
			THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
			&quot;AS IS&quot; AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING,
			BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
			FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL
			THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
			INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
			(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
			SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
			HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
			STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
			ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
			OF THE POSSIBILITY OF SUCH DAMAGE.
		</p>
		<h2 id="wix">wix:</h2>
		<h3 id="copyright--net-foundation-and-contributors">
			Copyright{' '}
			<span role="img" aria-label="copyright">
				©️
			</span>{' '}
			.NET Foundation and contributors.
		</h3>
		<p>
			This software is released under the Microsoft Reciprocal License
			(MS-RL) (the &quot;License&quot;); you may not use the software
			except in compliance with the License.
		</p>
		<p>
			The text of the Microsoft Reciprocal License (MS-RL) can be found
			online at:{' '}
			<a
				href="http://opensource.org/licenses/ms-rl"
				target="_blank"
				rel="noopener noreferrer">
				http://opensource.org/licenses/ms-rl
			</a>
			&nbsp; (see below).
		</p>
		<p>
			The source code for WiX Toolset v3.11.2 (and modifications made by
			Autodesk, if any) is available from{' '}
			<a
				href="https://nam11.safelinks.protection.outlook.com/?url=http%3A%2F%2Fwww.autodesk.com%2Flgplsource&amp;data=05|01|michelle.hu1@autodesk.com|5f0cb60c46f84b1004ee08da95aeac81|67bff79e7f914433a8e5c9252d2ddc1d|0|0|637986874685576559|Unknown|TWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D|3000|||&amp;sdata=AB55dnjdg4V1Iz%2BEb1wPnnh91UfE2ev%2BwOqha53%2FR1c%3D&amp;reserved=0"
				target="_blank"
				rel="noopener noreferrer">
				www.autodesk.com/lgplsource
			</a>
			.
		</p>
		<p>Microsoft Reciprocal License (MS-RL)</p>
		<p>
			This license governs use of the accompanying software. If you use
			the software, you accept this license. If you do not accept the
			license, do not use the software.
		</p>

		<ol>
			<li>
				<p>Definitions</p>
				<p>
					The terms &quot;reproduce,&quot; &quot;reproduction,&quot;
					&quot;derivative works,&quot; and &quot;distribution&quot;
					have the same meaning here as under U.S. copyright law.
				</p>
				<p>
					A &quot;contribution&quot; is the original software, or any
					additions or changes to the software.
				</p>
				<p>
					A &quot;contributor&quot; is any person that distributes its
					contribution under this license.
				</p>
				<p>
					&quot;Licensed patents&quot; are a contributor&#39;s patent
					claims that read directly on its contribution.
				</p>
			</li>
			<li>
				<p>Grant of Rights</p>
				<p>
					(A) Copyright Grant- Subject to the terms of this license,
					including the license conditions and limitations in section
					3, each contributor grants you a non-exclusive, worldwide,
					royalty-free copyright license to reproduce its
					contribution, prepare derivative works of its contribution,
					and distribute its contribution or any derivative works that
					you create.
				</p>
				<p>
					(B) Patent Grant- Subject to the terms of this license,
					including the license conditions and limitations in section
					3, each contributor grants you a non-exclusive, worldwide,
					royalty-free license under its licensed patents to make,
					have made, use, sell, offer for sale, import, and/or
					otherwise dispose of its contribution in the software or
					derivative works of the contribution in the software.
				</p>
			</li>
			<li>
				<p>Conditions and Limitations</p>
				<p>
					(A) Reciprocal Grants- For any file you distribute that
					contains code from the software (in source code or binary
					format), you must provide recipients the source code to that
					file along with a copy of this license, which license will
					govern that file. You may license other files that are
					entirely your own work and do not contain code from the
					software under any terms you choose.
				</p>
				<p>
					(B) No Trademark License- This license does not grant you
					rights to use any contributors&#39; name, logo, or
					trademarks.
				</p>
				<p>
					(C) If you bring a patent claim against any contributor over
					patents that you claim are infringed by the software, your
					patent license from such contributor to the software ends
					automatically.
				</p>
				<p>
					(D) If you distribute any portion of the software, you must
					retain all copyright, patent, trademark, and attribution
					notices that are present in the software.
				</p>
				<p>
					(E) If you distribute any portion of the software in source
					code form, you may do so only under this license by
					including a complete copy of this license with your
					distribution. If you distribute any portion of the software
					in compiled or object code form, you may only do so under a
					license that complies with this license.
				</p>
				<p>
					(F) The software is licensed &quot;as-is.&quot; You bear the
					risk of using it. The contributors give no express
					warranties, guarantees or conditions. You may have
					additional consumer rights under your local laws which this
					license cannot change. To the extent permitted under your
					local laws, the contributors exclude the implied warranties
					of merchantability, fitness for a particular purpose and
					non-infringement.
				</p>
			</li>
		</ol>
		<p>
			IF THIS AUTODESK PRODUCT HAS BEEN LABELED AND IDENTIFIED AS CITRIX
			READY, then this means that this Autodesk software has completed
			validation testing with Citrix® Presentation Server™/XenApp™
			software through the Citrix Ready program. The Citrix Ready
			designation identifies products that are compatible with a Citrix
			application delivery environment. To find out more, visit{' '}
			<a
				href="http://www.autodesk.com/citrix"
				target="_blank"
				rel="noopener noreferrer">
				www.autodesk.com/citrix
			</a>
			. Citrix is a registered trademark and the Citrix Ready logo(s) is a
			trademark of Citrix Systems, Inc.
		</p>
		<p>
			Additional Disclaimer: Whether this Autodesk Product has been
			labeled and identified as Citrix Ready, or this Autodesk product
			just works on the Citrix platform but has not been labeled and
			identified as Citrix Ready, please note that the Citrix application
			is network-based, and performance of Autodesk Applications on the
			Citrix Platform may vary with network performance. The Autodesk
			software does not include the Citrix application, nor does Autodesk
			provide direct support for issues with the Citrix application. Users
			should contact Citrix directly with questions related to procurement
			and operation of the Citrix application.
		</p>
		<h2 id="yaml">yaml:</h2>
		<p>
			Copyright Eemeli Aro &lt;
			<a
				href="mailto:eemeli@gmail.com"
				target="_blank"
				className="url"
				rel="noopener noreferrer">
				eemeli@gmail.com
			</a>
			&gt;
		</p>
		<p>
			Permission to use, copy, modify, and/or distribute this software for
			any purpose with or without fee is hereby granted, provided that the
			above copyright notice and this permission notice appear in all
			copies.
		</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot; AND THE AUTHOR DISCLAIMS
			ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED
			WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE
			AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL
			DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA
			OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER
			TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
			PERFORMANCE OF THIS SOFTWARE.
		</p>
		<h2 id="zipp">zipp:</h2>
		<p>Copyright Jason R. Coombs</p>
		<p>
			Permission is hereby granted, free of charge, to any person
			obtaining a copy of this software and associated documentation files
			(the &quot;Software&quot;), to deal in the Software without
			restriction, including without limitation the rights to use, copy,
			modify, merge, publish, distribute, sublicense, and/or sell copies
			of the Software, and to permit persons to whom the Software is
			furnished to do so, subject to the following conditions:
		</p>
		<p>
			The above copyright notice and this permission notice shall be
			included in all copies or substantial portions of the Software.
		</p>
		<p>
			THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY
			KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
			WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
			NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
			BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
			ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
			CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
			SOFTWARE.
		</p>
	</>
);
